import React from "react";

const Footer = () => {
  return (
    <footer className="h-[56px] bg-green flex items-center">
      <p className="text-level-5 px-[20px] md:px-[50px] lg:px-[100px] text-[var(--text-gray-color)]">
        © {new Date().getFullYear()} Roselea. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
